import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/discounts',
    name: 'discounts',
    meta: {
      title: 'Discounts'
    },
    component: () => import('@/views/discounts/DiscountListView.vue')
  },
  {
    path: '/discounts/create',
    name: 'discount-create',
    meta: {
      title: 'Create Discount'
    },
    component: () => import('@/views/discounts/DiscountCreateView.vue')
  },
  {
    path: '/discounts/:id',
    name: 'discount-edit',
    props: true,
    meta: {
      title: 'Edit Discount'
    },
    component: () => import('@/views/discounts/DiscountEditView.vue'),
    children: [
      {
        path: '/discounts/:id/f/:section',
        name: 'discount-edit-section',
        props: true,
        meta: {
          title: 'Edit Discount'
        },
        component: () => import('@/views/discounts/DiscountEditView.vue')
      }
    ]
  }
]

export default routes
